module.exports = __webpack_public_path__ + "img/stock.8860fb64.svg";